const toFiniteNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const clamp = (value, min, max) => {
  if (max <= min) return min;
  return Math.min(Math.max(value, min), max);
};

const getScreenSizeFromWidth = (width) => {
  const safeWidth = Math.max(0, toFiniteNumber(width, 0));
  if (safeWidth < 600) return "small";
  if (safeWidth < 1090) return "medium";
  return "large";
};

const GAP_LIMITS_BY_SCREEN_SIZE = {
  small: { min: 12, max: 12 },
  medium: { min: 12, max: 14 },
  large: { min: 12, max: 24 },
};

export const getCenteredTabScrollOffset = ({
  tabX,
  tabWidth,
  containerWidth,
  contentWidth,
} = {}) => {
  const safeTabX = toFiniteNumber(tabX, 0);
  const safeTabWidth = Math.max(0, toFiniteNumber(tabWidth, 0));
  const safeContainerWidth = Math.max(0, toFiniteNumber(containerWidth, 0));
  const safeContentWidth = Math.max(0, toFiniteNumber(contentWidth, 0));

  if (safeContainerWidth <= 0 || safeContentWidth <= safeContainerWidth) {
    return 0;
  }

  const desiredOffset = safeTabX + safeTabWidth / 2 - safeContainerWidth / 2;
  const maxScroll = safeContentWidth - safeContainerWidth;

  return clamp(desiredOffset, 0, maxScroll);
};

export const getResponsiveTabGap = ({
  preferredGap,
  screenSize,
  screenWidth,
  containerWidth,
  tabWidthsTotal,
  tabCount,
  measuredTabCount,
} = {}) => {
  const safeTabCount = Math.max(0, Math.floor(toFiniteNumber(tabCount, 0)));
  if (safeTabCount <= 1) return 0;

  const resolvedScreenSize =
    typeof screenWidth === "number" && Number.isFinite(screenWidth)
      ? getScreenSizeFromWidth(screenWidth)
      : screenSize;
  const limits =
    GAP_LIMITS_BY_SCREEN_SIZE[resolvedScreenSize] ||
    GAP_LIMITS_BY_SCREEN_SIZE.large;
  const safePreferredGap = Math.max(
    0,
    toFiniteNumber(preferredGap, GAP_LIMITS_BY_SCREEN_SIZE.large.min),
  );

  let resolvedGap = clamp(safePreferredGap, limits.min, limits.max);

  const safeContainerWidth = Math.max(0, toFiniteNumber(containerWidth, 0));
  const safeTabWidthsTotal = Math.max(0, toFiniteNumber(tabWidthsTotal, 0));
  const safeMeasuredCount = Math.max(
    0,
    Math.floor(toFiniteNumber(measuredTabCount, 0)),
  );
  const hasAllTabsMeasured = safeMeasuredCount === safeTabCount;

  if (
    hasAllTabsMeasured &&
    safeContainerWidth > 0 &&
    safeTabWidthsTotal > 0 &&
    safeTabCount > 1
  ) {
    const maxGapToFit =
      (safeContainerWidth - safeTabWidthsTotal) / (safeTabCount - 1);
    if (Number.isFinite(maxGapToFit)) {
      resolvedGap = Math.max(limits.min, Math.min(resolvedGap, maxGapToFit));
    }
  }

  return Math.max(limits.min, resolvedGap);
};
